import { useCallback, useEffect, useState } from "react";
import { useI18n } from "../i18n/useI18n";

const SHOW_AFTER_PX = 380;

export function ScrollToTopButton() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-btn"
      onClick={goTop}
      aria-label={t("scrollTop.aria")}
      title={t("scrollTop.aria")}
    >
      <span aria-hidden>↑</span>
      <style>{`
        .scroll-top-btn {
          position: fixed;
          z-index: 85;
          right: max(1rem, env(safe-area-inset-right, 0px));
          bottom: max(1rem, env(safe-area-inset-bottom, 0px));
          width: 3.1rem;
          height: 3.1rem;
          border-radius: 50%;
          border: 1px solid var(--border);
          background: var(--surface);
          color: var(--accent);
          font-size: 1.3rem;
          font-weight: 700;
          line-height: 1;
          cursor: pointer;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.18);
          display: flex;
          align-items: center;
          justify-content: center;
          -webkit-tap-highlight-color: transparent;
          transition:
            background 0.15s ease,
            border-color 0.15s ease,
            opacity 0.12s ease;
        }
        .scroll-top-btn:hover {
          border-color: var(--accent-dim);
          background: var(--surface2);
        }
        .scroll-top-btn:active {
          opacity: 0.88;
        }
        .scroll-top-btn:focus:not(:focus-visible) {
          outline: none;
        }
      `}</style>
    </button>
  );
}
